var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-spinner"},[_c('div',{staticClass:"s-spinner-bounce1",style:({backgroundColor:_vm.color})}),_vm._v(" "),_c('div',{staticClass:"s-spinner-bounce2",style:({backgroundColor:_vm.color})}),_vm._v(" "),_c('div',{staticClass:"s-spinner-bounce3",style:({backgroundColor:_vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }